import React, {useMemo} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {List} from 'immutable';
import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';

import FreeEntryInputArea from '../FreeEntryInputArea.react';
import {useQuestionTranslationStore} from '../../shared/TranslationSection';
import {QuestionComponentProps} from '../../shared/QuestionComponent/QuestionComponent.react';

const FreeEntryInputWrapper = (props: QuestionComponentProps) => {
  const {showTranslations, translatedInfo} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question,
      translatedInfo: state.translatedQuestionInfo
    }))
  );

  const translatedInputs = useMemo(() => {
    const formattedInfo = translatedInfo?.inputs?.map((inputInfo) => {
      return {
        ...inputInfo,
        getId: () => inputInfo.id,
        getText: () => inputInfo.text
      };
    });
    return List(formattedInfo || []);
  }, [translatedInfo]);

  return (
    <FeatureFlag name='assignment_question_translations'>
      <FreeEntryInputArea
        {...props}
        showTranslations={showTranslations}
        translatedInputs={translatedInputs}
      />
      <FeatureFlag.Fallback>
        <FreeEntryInputArea {...props} />
      </FeatureFlag.Fallback>
    </FeatureFlag>
  );
};

export default FreeEntryInputWrapper;
